module.exports = __webpack_public_path__ + "img/fowler.d149ee7b.svg";